/**
 * Sabah raporu bildiriminin METİN üretimi (Sorgu Snapshot Faz 3, DEV-2968).
 *
 * Saf; `senkronOnKontrolMesaji` ile aynı gerekçe. Rapor gövdesi burada YAPISAL
 * olarak tiplenir (`@/services/...`ten import EDİLMEZ): plugin'i vue-imza-app de
 * kullanıyor ve o uygulamanın icrapro-app servis katmanı yok.
 */

export interface SabahRaporuPlanSatiri {
    plan_id: number;
    ad: string | null;
    uretilen_gorev: number;
    atlanan_dosya: number;
    biten: number;
    hatali: number;
    bekleyen: number;
    yeni_oneri: number;
    yuksek_oncelikli_oneri: number;
    hata: string | null;
}

export interface SabahRaporuGovdesi {
    gun: string;
    planlar: Array<SabahRaporuPlanSatiri>;
}

export interface SabahRaporuMesaji {
    baslik: string;
    metin: string;
    kritikMi: boolean;
}

export interface SabahRaporuToplami {
    uretilen: number;
    biten: number;
    hatali: number;
    bekleyen: number;
    yeniOneri: number;
    yuksekOncelikliOneri: number;
    atlananDosya: number;
    /** Üretimi çökmüş plan sayısı (`hata` dolu). */
    hataliPlan: number;
}

/** Plan satırlarını tek özete indirger; şerit ve bildirim aynı sayıyı gösterir. */
export function raporToplamiHesapla(planlar: Array<SabahRaporuPlanSatiri>): SabahRaporuToplami {
    const toplam: SabahRaporuToplami = {
        uretilen: 0,
        biten: 0,
        hatali: 0,
        bekleyen: 0,
        yeniOneri: 0,
        yuksekOncelikliOneri: 0,
        atlananDosya: 0,
        hataliPlan: 0
    };

    (planlar ?? []).forEach((satir) => {
        toplam.uretilen += Number(satir.uretilen_gorev) || 0;
        toplam.biten += Number(satir.biten) || 0;
        toplam.hatali += Number(satir.hatali) || 0;
        toplam.bekleyen += Number(satir.bekleyen) || 0;
        toplam.yeniOneri += Number(satir.yeni_oneri) || 0;
        toplam.yuksekOncelikliOneri += Number(satir.yuksek_oncelikli_oneri) || 0;
        toplam.atlananDosya += Number(satir.atlanan_dosya) || 0;
        if (satir.hata) toplam.hataliPlan += 1;
    });

    return toplam;
}

/**
 * Bildirim metni. `null` = bildirim gösterme.
 *
 * Hiç plan koşmamış bir gün için bildirim çıkarmıyoruz: rapor ucu o gün üretim
 * yapmamış planları zaten listelemiyor, dolayısıyla boş liste "dün gece senkron
 * yoktu" demektir ve kullanıcıyı ilgilendirmez.
 */
export function sabahRaporuMesajiOlustur(
    rapor: SabahRaporuGovdesi | null
): SabahRaporuMesaji | null {
    if (!rapor || !Array.isArray(rapor.planlar) || rapor.planlar.length === 0) {
        return null;
    }

    const toplam = raporToplamiHesapla(rapor.planlar);
    const parcalar: string[] = [`${toplam.biten}/${toplam.uretilen} dosya senkronlandı`];

    if (toplam.bekleyen > 0) parcalar.push(`${toplam.bekleyen} bekliyor`);
    if (toplam.hatali > 0) parcalar.push(`${toplam.hatali} hatalı`);

    parcalar.push(
        toplam.yuksekOncelikliOneri > 0
            ? `${toplam.yeniOneri} yeni öneri — ${toplam.yuksekOncelikliOneri} yüksek`
            : `${toplam.yeniOneri} yeni öneri`
    );

    const satirlar: string[] = [parcalar.join(" · ")];

    if (toplam.hataliPlan > 0) {
        const plan = toplam.hataliPlan === 1 ? "Bir planın" : `${toplam.hataliPlan} planın`;
        satirlar.push(`${plan} üretimi hata aldı; ayrıntı Görevler sayfasındaki rapor şeridinde.`);
    }

    return {
        baslik: "Gece senkronu raporu",
        metin: satirlar.join("\n"),
        // Ses yalnız gerçekten kötü haberde: sabah raporu normalde bilgilendirmedir.
        kritikMi: toplam.hataliPlan > 0 || toplam.hatali > 0
    };
}
